const createComponentModule = require('../../../common/utils/createComponentModule');
const isMatchedBreakpoint = require('../../../common/utils/isMatchedBreakpoint');
const { parseDateByRegionFormat } = require('../../../common/utils/countriesUtils');

const isFocusDesktop = isMatchedBreakpoint.matches('bp_1025', 'min-width');

module.exports = createComponentModule(
  '.field-date',
  (fieldDateComponent) => {
    const inputDate = fieldDateComponent.querySelector('.input');
    const { maxDate } = inputDate.dataset;

    const formattedMaxBirthday = () => {
      const yearLimit = 14;
      const now = new Date();
      return `${now.getFullYear() - yearLimit}-${
        (`0${now.getMonth() + 1}`).slice(-2)}-${
        (`0${now.getDate()}`).slice(-2)}`;
    };

    const formattedBirthday = (value, formatted = true) => {
      if (typeof value === 'undefined' || value === '') {
        return '';
      }

      if (formatted) {
        return parseDateByRegionFormat(value);
      }

      return value.split('/').reverse().join('-');
    };

    if (isFocusDesktop) {
      inputDate.addEventListener('blur', (e) => {
        const oldValue = e.target.value;
        e.target.type = 'text';
        e.target.value = formattedBirthday(oldValue);
      });
      inputDate.addEventListener('focus', (e) => {
        const oldValue = e.target.value;
        e.target.type = 'date';
        e.target.max = maxDate || formattedMaxBirthday();
        e.target.value = formattedBirthday(oldValue, false);
      });
    } else {
      inputDate.addEventListener('focus', (e) => {
        const inputTemp = document.createElement('input');
        inputTemp.type = 'date';
        inputTemp.max = maxDate || formattedMaxBirthday();
        inputTemp.className = e.target.className;
        inputTemp.value = formattedBirthday(e.target.value, false);
        inputTemp.addEventListener('blur', (event) => {
          const inputText = event.target.nextSibling;
          event.target.remove();
          inputText.style = '';
        });
        inputTemp.addEventListener('change', (event) => {
          const inputText = event.target.nextSibling;
          inputText.value = formattedBirthday(event.target.value);
        });
        e.target.insertAdjacentElement('beforebegin', inputTemp);
        e.target.style = 'display: none;';
        inputTemp.focus();
      });
    }
  },
);
